import EmptyStateNew from '../../../components/empty-state/EmptyStateNew';
import {
    FolderPlusIcon,
    QueueListIcon,
    RectangleStackIcon,
    SquaresPlusIcon,
    PlusCircleIcon,
    TableCellsIcon,
} from '@heroicons/react/20/solid';
import { ButtonGroup } from '@cimplico/components';

type EmptyFormProps = {
    templateName: string;
    onAdd: (type: 'LIST' | 'SECTION_GROUP' | 'SECTION' | 'FIELD' | 'TABLE') => void;
};
function EmptyForm({ templateName, onAdd }: EmptyFormProps): JSX.Element {
    return (
        <EmptyStateNew
            title="No properties found"
            helpText={`Add new list, section groups or sections to "${templateName}".`}
            icon={<RectangleStackIcon />}
            primaryAction={
                <ButtonGroup
                    label="New section"
                    leftIcon={<FolderPlusIcon />}
                    type="secondary"
                    size="sm"
                    onClick={(): void => onAdd('SECTION')}
                >
                    <ButtonGroup.SecondaryAction label="New field" leftIcon={<PlusCircleIcon />} onClick={(): void => onAdd('FIELD')} />
                    <ButtonGroup.SecondaryAction
                        label="New section group"
                        leftIcon={<SquaresPlusIcon />}
                        onClick={(): void => onAdd('SECTION_GROUP')}
                    />
                    <ButtonGroup.SecondaryAction label="New Table" leftIcon={<TableCellsIcon />} onClick={(): void => onAdd('TABLE')} />
                    <ButtonGroup.SecondaryAction label="New list" leftIcon={<QueueListIcon />} onClick={(): void => onAdd('LIST')} />
                </ButtonGroup>
            }
        />
    );
}

export default EmptyForm;
